import React, {PureComponent} from "react"
import {Provider} from "react-redux"
import Helmet from "react-helmet"
import ReduxToastr from "react-redux-toastr"
import apolloClient, {ApolloProvider} from "@irati/utils/services/apollo"

import {ACCOUNT} from "@irati-web/app/src/routeConfig"
import {store} from "@irati/store"
import TooltipNotification from "@irati/ui/src/TooltipNotification/TooltipNotification"
import CookieNotification from "@irati-web/platform/src/components/CookieNotification"
import NavigationBlocker from "@irati/utils/history/routing/Blocker"
import {LangLoader} from "@irati/utils/lang"
import {LangProvider} from "@irati/utils/lang/Provider"
import {ContentCardProvider} from "@irati/braze/hooks/Provider"
import {IntlHookProvider} from "@irati/utils/lang/intlHook"

export default class App extends PureComponent {
  render() {
    return (
      <Provider store={store}>
        <ApolloProvider client={apolloClient}>
          <LangProvider>
            <LangLoader buckets={[ACCOUNT, "platform", "errors"]}>
              <IntlHookProvider>
                <ContentCardProvider>
                  <div>
                    <Helmet>
                      <title>Perkbox</title>
                    </Helmet>
                    <ReduxToastr preventDuplicates transitionIn="fadeIn" transitionOut="fadeOut" position="top-right" />
                    <TooltipNotification />
                    <NavigationBlocker />
                    {this.props.children}
                    <CookieNotification />
                  </div>
                </ContentCardProvider>
              </IntlHookProvider>
            </LangLoader>
          </LangProvider>
        </ApolloProvider>
      </Provider>
    )
  }
}
